import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Sound from 'react-sound';

class PlaySound extends PureComponent {
  render() {
    const { url, play, onFinish } = this.props;
    const isPlaying = play ? Sound.status.PLAYING : Sound.status.STOPPED;
    return <Sound url={url} playStatus={isPlaying} onFinishedPlaying={onFinish} />;
  }
}

PlaySound.propTypes = {
  url: PropTypes.string,
  play: PropTypes.bool,
  onFinish: PropTypes.func,
};

PlaySound.defaultProps = {
  url: '',
  play: false,
  onFinish: () => {},
};

export default PlaySound;
